import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Minimalist Avian / Bird Icon for Bioacoustic Monitoring
 */
export const MinimalBirdIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="16" cy="7" r="0.8" fill="currentColor" stroke="none" />
      <path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 18z" />
      <path d="m20 7 2.2 .5-2.2 .5" />
      <path d="M10 18v3" />
      <path d="M14 17.75V21" />
      <path d="M7 18a6 6 0 0 0 3.84-10.61" />
    </g>
  </SvgIcon>
);

export default MinimalBirdIcon;
